import { createRouter as _createRouter, createWebHistory } from 'vue-router';
import { useUserStore } from '@/stores/user';

export function createRouter() {
  const userStore = useUserStore();
  const router = _createRouter({
    history: createWebHistory(''),
    routes: [
      {
        path: '/',
        component: () => import('../views/AppLayout.vue'),
        children: [
          {
            path: '',
            name: 'slots',
            component: () => import('../views/ChallengeView.vue'),
          },
          {
            path: 'invite',
            name: 'invite',
            component: () => import('../views/InviteView.vue'),
            props: (route) => ({ msg: route.query.msg }),
          },
          {
            path: 'challenge',
            name: 'challenge',
            component: () => import('../views/ShowcaseView.vue'),
            props: (route) => ({ code: route.query.c }),
          },
          {
            path: 'create-challenge',
            name: 'create-challenge',
            component: () => import('../views/ChallengeCreatorView.vue'),
          },
          {
            path: 'rules',
            name: 'rules',
            component: () => import('../views/RulesView.vue'),
          },
          {
            path: 'igdb',
            name: 'igdb',
            component: () => import('../views/IgdbSearchView.vue'),
          },
          {
            path: 'games',
            name: 'game-list',
            component: () => import('../views/GameListView.vue'),
          },
          {
            path: 'games/:id(\\d+)',
            name: 'game-detail',
            component: () => import('../views/GameDetailView.vue'),
            props: (route) => ({ id: Number(route.params.id) }),
          },
          {
            path: 'ui-sandbox',
            name: 'ui-sandbox',
            component: () => import('../views/UISandboxView.vue'),
          },
          {
            path: 'admin',
            name: 'admin',
            meta: { requiresAdmin: true },
            component: () => import('../views/AdminView.vue'),
          },
        ],
      },
      {
        path: '/overlay',
        component: () => import('../views/ChallengeOverlayView.vue'),
        meta: { overlay: true },
        props: (route) => ({ code: route.query.c }),
      },
    ],
  });

  router.beforeEach(async (to, from, next) => {
    if (to.meta.requiresAdmin) {
      if (userStore.isLoading) {
        await userStore.onUserLoadedObservable;
      }
      if (!userStore.isAdmin) {
        return next('/');
      }
    }
    next();
  });

  router.afterEach((to) => {
    document.body.classList.toggle('overlay', !!to.meta.overlay);
  });
  return router;
}
